import * as React from 'react'

import { Icon, IconProps } from './Icon'

export const RemoveIcon: React.FC<IconProps> = props => (
  <Icon fill="currentColor" {...props}>
    <path d="M5 13V11H19V13H5Z" />
  </Icon>
)
